export default __webpack_public_path__ + "static/media/imageTwo.1ece41dd.png";